// extracted by mini-css-extract-plugin
module.exports = {"page__overlay__wrapper":"spinner_page__overlay__wrapper__2RpUH","center__frame":"spinner_center__frame__hYqO-","spinners":"spinner_spinners__3ouCI"};